import type { ParsedStatement } from './types'
import type { DiagramScene } from '../api/types'

export interface StatementNodeMaps {
    stmtToNode: Map<number, string>
    nodeToStmt: Map<string, number>
}

export function buildStatementNodeMaps(
    statements: ParsedStatement[],
    scene: DiagramScene | null,
): StatementNodeMaps {
    const stmtToNode = new Map<number, string>()
    const nodeToStmt = new Map<string, number>()

    if (!scene) return { stmtToNode, nodeToStmt }

    const actionNodes = scene.nodes.filter(
        n => n.semanticRole.toUpperCase().includes('ACTION'),
    )

    for (let i = 0; i < statements.length; i++) {
        const stmt = statements[i]
        if (!stmt.action) continue

        const match = actionNodes.find(n => {
            if (n.displayName.toLowerCase() !== stmt.action.toLowerCase()) return false
            if (n.actorLabel && stmt.subjects.length > 0) {
                return stmt.subjects.some(
                    s => s.toLowerCase() === n.actorLabel!.toLowerCase(),
                )
            }
            return true
        })

        if (match) {
            stmtToNode.set(i, match.id)
            nodeToStmt.set(match.id, i)
        }
    }

    return { stmtToNode, nodeToStmt }
}
